import { getQueryMarkup } from './getQuery';

export async function getVerticalTermIndexItemMarkup( termId, offset, numPosts ) {

    const queryObj = {
        "orderby": "date",
        "order": "DESC",
        "post_type": [ "post", "sponsored_post" ],
        "offset": offset,
        "posts_per_page": numPosts,
        "tax_query": [{
            "taxonomy": "vertical",
            "field": "term_id",
            "terms": termId
        }]
    };
    const queryParam = encodeURIComponent(JSON.stringify(queryObj));

    try {

        const res = await getQueryMarkup( queryParam,'index_item' );
        const body = await res.json();
        return body.markup;

    } catch (e) {

        console.error('Developer message: Error in fetching vertical term data with index item markup: ' + e);

        throw e;

    }

}
